/** MIDI note number utilities and equal-temperament frequency helpers. */

export const A4_MIDI = 69;
export const A4_HZ = 440;

export function midiToFrequency(midiNote: number): number {
  return A4_HZ * Math.pow(2, (midiNote - A4_MIDI) / 12);
}

export function frequencyToMidi(hz: number): number {
  return Math.round(12 * Math.log2(hz / A4_HZ) + A4_MIDI);
}

export function clampMidiNote(note: number): number {
  return Math.max(0, Math.min(127, Math.round(note)));
}

const NOTE_NAMES = [
  "C",
  "C#",
  "D",
  "D#",
  "E",
  "F",
  "F#",
  "G",
  "G#",
  "A",
  "A#",
  "B",
] as const;

export type NoteName = (typeof NOTE_NAMES)[number];

export function midiToNoteName(midiNote: number): { name: NoteName; octave: number } {
  const n = clampMidiNote(midiNote);
  return {
    name: NOTE_NAMES[n % 12],
    octave: Math.floor(n / 12) - 1,
  };
}

export function noteNameToMidi(name: string, octave: number): number {
  const idx = NOTE_NAMES.indexOf(name.toUpperCase().replace("♯", "#") as NoteName);
  if (idx < 0) throw new Error(`Unknown note name: ${name}`);
  return clampMidiNote((octave + 1) * 12 + idx);
}

/** Common range for virtual piano UI / Phase 1 demos. */
export const MIDDLE_C = 60; // C4
export const DEFAULT_RANGE = { low: 36, high: 96 } as const; // C2–C7
